import React, { useState } from "react";
import { TextField, Button, Card, CardContent, Typography, Alert, CircularProgress } from "@mui/material";
import axios from "axios";
import endpoints from "../../../endpoint";

const NotificationSender = () => {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSendNotification = async () => {
    if (!title || !body) {
      setError("Title and Body are required!");
      return;
    }

    setLoading(true);
    setMessage(null);
    setError(null);

    try {
      const response = await axios.post(endpoints.serverBaseUrl + "api/sendmultiple", {
        title,
        body,
        image,
      }, {
        headers: {

          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },

      });

      if (response.data.success) {
        setMessage("✅ Notification sent successfully!");
        setTitle("");
        setBody("");
        setImage("");
      } else {
        setError("❌ Failed to send notification.");
      }
    } catch (err) {
      setError("❌ Error sending notification.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ maxWidth: 500, margin: "auto", mt: 5, p: 3, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          Send Push Notification
        </Typography>

        {message && <Alert severity="success">{message}</Alert>}
        {error && <Alert severity="error">{error}</Alert>}

        <TextField
          fullWidth
          label="Title"
          variant="outlined"
          margin="normal"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <TextField
          fullWidth
          label="Body"
          variant="outlined"
          margin="normal"
          value={body}
          onChange={(e) => setBody(e.target.value)}
        />
        <TextField
          fullWidth
          label="Image URL (Optional)"
          variant="outlined"
          margin="normal"
          value={image}
          onChange={(e) => setImage(e.target.value)}
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          onClick={handleSendNotification}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : "Send Notification"}
        </Button>
      </CardContent>
    </Card>
  );
};

export default NotificationSender;
